import { useEffect, useState } from 'react';

import { Logger } from '@eluve/logger';

import { calculateTotalDuration } from './calculateTotalDuration';
import { useUserFileSystemStore } from './user-file-system.store';

export const useTotalAudioDurationFromLocalFiles = (
  tenantId: string,
  appointmentId: string,
  logger: Logger,
) => {
  const userFileSystem = useUserFileSystemStore(
    (state) => state.userFileSystem,
  );
  const [totalDuration, setTotalDuration] = useState(0);

  useEffect(
    function calculateAndSetTotalDuration() {
      (async () => {
        const totalDuration = await calculateTotalDuration({
          userFileSystem,
          appointmentId,
          logger,
        });
        setTotalDuration(totalDuration);
      })();
    },
    [userFileSystem, tenantId, appointmentId, logger],
  );

  return totalDuration;
};
